import React, { useEffect, useRef, useState } from 'react';
import { getGooglePaymentsClient } from '~/services/wallets';
import './styles.css';

/**
 * Botão oficial do Google Pay (brand guidelines exigem o botão gerado pelo SDK).
 */
export function GooglePayButton({ onClick, disabled }) {
  const containerRef = useRef(null);
  const onClickRef = useRef(onClick);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    onClickRef.current = onClick;
  }, [onClick]);

  useEffect(() => {
    let cancelled = false;

    getGooglePaymentsClient()
      .then(client => {
        if (cancelled || !containerRef.current) return;

        const button = client.createButton({
          buttonColor: 'black',
          buttonType: 'pay',
          buttonSizeMode: 'fill',
          buttonLocale: 'pt',
          onClick: () => {
            if (onClickRef.current) onClickRef.current();
          },
        });

        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(button);
      })
      .catch(err => {
        console.warn('[GooglePay] createButton falhou:', err?.message || err);
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) return null;

  return (
    <div
      ref={containerRef}
      className={`wallet-button-container ${
        disabled ? 'wallet-button-disabled' : ''
      }`}
    />
  );
}

/**
 * Botão oficial do Apple Pay via CSS (-webkit-appearance: -apple-pay-button),
 * disponível nativamente em Safari/WebKit — sem SDK.
 */
export function ApplePayButton({ onClick, disabled }) {
  return (
    <div className="wallet-button-container">
      <button
        type="button"
        className="apple-pay-button"
        aria-label="Pagar com Apple Pay"
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
}
